<template>
  <div class="renewtip">
    <h2>卓越的行情软件，专业的投资选择！</h2>
    <div class="con">
      <p>
        亲爱的<strong>{{userName}}</strong>:
      </p>
      <p>
        您使用的<span class="font-blue">{{product.name}}</span>将于
        <em>{{expireTime | dateFormat("yyyy-MM-dd")}}</em>日到期，到期后将无法正常使用，为了不影响您的投资操作，现在续费立享优惠！
      </p>
      <a href="#" @click="renew"></a>
    </div>
    <div class="footer">
      <p>如有疑问，请拨打电话021-20219999，客服将第一时间帮你解决。</p>
      <!-- <a href="">大智慧网上商城</a> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      d: this.$route.query.d,
      data: this.$route.query.userinfo,
      token: this.$route.query.token,
      userName: '',
      expireTime: 0,
      product: {},
    };
  },
  created() {
    document.title = "续费提示";
    // var req = new XMLHttpRequest();
    // req.open('GET', document.location, false);
    // req.send(null);
    // var data = req.getResponseHeader("DzhSession");
    // if (this.data && this.d) {
    //   // this.data = data;
    //   this.initData();
    // } else {
    //   window.close()
    // }
    this.initData();
  },
  mounted() {
    document.querySelector("body").style.minWidth = 300 + 'px'
  },
  methods: {
    initData() {
      var params = {
        d: this.d,
        data: this.token
      };
      this.$post("/client/renewTip", params)
        .then(response => {
          if (response.code === 0) {
            this.$storage.saveUserName(this.userName);
            this.userName = response.data.userName;
            this.product = response.data.product;
            this.expireTime = response.data.expireTime;
          } else if (response.code === 101) {
            window.close();
          } else {
            window.close();
          }
        })
        .catch(err => {
          alert("网络异常，请稍后重试");
          window.close();
        });
    },
    renew() {
      var arr = Object.keys(this.product);
      if (arr.length == 0) {
        this.$router.push("/");
        return false;
      }
      var status = this.product.status;
      if (status && status == 1) {
        var params = {
          id: this.product.id
        };
        this.$get("/client/renewProduct", params)
          .then(response => {
            if (response.code === 0) {
              // var url = window.g.clientRenewUrl;
              // url = url.replace(/{pid}/, this.product.id);
              // var url = `https://paytestm.gw.com.cn/pay-mall/client/product.html?pid=${this.product.id}&token=${this.token}`
              // window.location.href = url;
              this.$router.push({name: 'ClientProduct', query: {token: this.token, pid: this.product.id, s: "renew"}})
            } else {
              this.$router.push("/order/confirm/" + this.product.id + "?s=renew");
            }
          })
          .catch(err => {
            alert("网络异常，请稍后重试");
          });
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style scoped>
.renewtip{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/client/RenewTip.vue